import React from 'react';
import styles from './components.module.css';

export interface FormHeaderProps {
  title?: string;
  description?: string;
}

export const FormHeader: React.FC<FormHeaderProps> = ({
  title,
  description,
}) => {
  if (!title && !description) return null;

  return (
    <div className={styles.formHeader}>
      {title && <h1 className={styles.formTitle}>{title}</h1>}
      {description && <p className={styles.formDescription}>{description}</p>}
    </div>
  );
};

export default FormHeader;
